import script from "./MarketingContacts.vue?vue&type=script&setup=true&lang=js"
export * from "./MarketingContacts.vue?vue&type=script&setup=true&lang=js"

import "./MarketingContacts.vue?vue&type=style&index=0&id=a3c03b78&lang=scss"

const __exports__ = script;

export default __exports__